module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid8_710x708.74a75bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid8_710x708.jpg
// module id = r0kO
// module chunks = 0